export default {
	"3fc98ff96c77fb58e862912d76e0ac75": "地址获取失败，请手动选择省市区",
	"3465345a5f20c9a2086c351800c2d264": "订单地址修改成功",
	"762d7101cd72237f2109c1f950e7d669": "订单地址修改失败",
	"f98aeeb32a5a904d1e14561a20fc2566": "修改地址",
	"e7a990e66eb5601aecc8cc7033b7f96c": "新增地址",
	"f6cdabf801b598f87cc608a3edbd5ecb": "保存",
	"7ac104292a4e5b51e139fde0e8468987": "我的地址页_默认地址开关",
	"284445c667bcf99437898e15c99a59c1": "我的地址页_保存并使用",
	"07cac475bf9d525a4782d4ee8136fab8": "地址保存成功",
	"988b0e88ff6676c8a04b6908f6efe410": "查询失败了",
	"b6df6577228146abbc58ec803bd5cdb2": "选择地址失败",
	"124e146cbd95dc538221ed4172223f56": "地图加载出错了",
	"abd2cc4565019da6af8b6584fa42c6b9": "姓名",
	"0ce21a82752147cfba0e3654b13f5453": "身份证",
	"43953dd11cc7109f6279d56bc483cd18": "保存并使用"
}
